import React from 'react';
import { usePublisherMe } from '~/hooks/api/usePublisherMe';

type HasRoleProps = {
  roles: ('Administrator' | 'ShiftLeader' | 'Vip' | 'Publisher')[];
  children: React.ReactNode;
};

export const HasRole = (props: HasRoleProps) => {
  const { data: publisherData } = usePublisherMe();

  if (!publisherData) {
    return null;
  }

  const roles: ('Administrator' | 'ShiftLeader' | 'Vip' | 'Publisher')[] = [];
  if (publisherData.isAdministrator) {
    roles.push('Administrator');
  }
  if (publisherData.isVip) {
    roles.push('Vip');
  }
  if (publisherData.isPublisher) {
    roles.push('Publisher');
  }
  if (publisherData.isShiftLeader) {
    roles.push('ShiftLeader');
  }

  const hasAnyRequiredRole = roles.some((role) => props.roles.includes(role));
  return <>{hasAnyRequiredRole && props.children}</>;
};

export const useHasRole = (
  roles: ('Administrator' | 'ShiftLeader' | 'Vip' | 'Publisher')[]
) => {
  const { data: publisherData } = usePublisherMe();
  const publisherRoles: (
    | 'Administrator'
    | 'ShiftLeader'
    | 'Vip'
    | 'Publisher'
  )[] = [];
  if (publisherData?.isAdministrator) {
    publisherRoles.push('Administrator');
  }
  if (publisherData?.isVip) {
    publisherRoles.push('Vip');
  }
  if (publisherData?.isPublisher) {
    publisherRoles.push('Publisher');
  }
  if (publisherData?.isShiftLeader) {
    publisherRoles.push('ShiftLeader');
  }
  return roles.some((role) => publisherRoles.includes(role));
};

export default HasRole;
